import dynamic from "next/dynamic";
const HubspotDynamicFormWithBulletsSideBySideIframeComponent = dynamic(()=>import("./hubspot-dynamic-form-with-bullets-side-by-side-iframe-component"));
import HubspotDynamicFormWithBulletsSideBySideIframeConfig from "./hubspot-dynamic-form-with-bullets-side-by-side-iframe-config";
import HubspotDynamicFormWithBulletsSideBySideIframeAdvancedConfig from "./hubspot-dynamic-form-with-bullets-side-by-side-iframe-advanced-config";
export default {
    HubspotDynamicFormWithBulletsSideBySideIframeComponent,
    HubspotDynamicFormWithBulletsSideBySideIframeConfig,
    HubspotDynamicFormWithBulletsSideBySideIframeAdvancedConfig
};
